import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    difficultyLevelListLoading: false,
    difficultyLevelListSuccess: null,
    difficultyLevelListError: '',

    getDifficultyLevelLoading: false,
    getDifficultyLevelSuccess: null,
    getDifficultyLevelError: '',

    createDifficultyLevelLoading: false,
    createDifficultyLevelSuccess: {},
    createDifficultyLevelError: '',
}

export const difficultyLevelSlice = createSlice({
    name: 'difficultyLevel',
    initialState, 
    reducers: {
        setDifficultyLevelListLoading: (state) => {
            state.difficultyLevelListLoading = true;
            state.difficultyLevelListSuccess = null;
            state.difficultyLevelListError = '';
        },
        setDifficultyLevelListSuccess: (state, action) => {
            state.difficultyLevelListLoading = false;
            state.difficultyLevelListSuccess = action.payload;
            state.difficultyLevelListError = '';
        },
        setDifficultyLevelListError: (state, action) => {
            state.difficultyLevelListLoading = false;
            state.difficultyLevelListSuccess = null;
            state.difficultyLevelListError = action.payload;
        },
        setGetDifficultyLevelLoading: (state) => {
            state.getDifficultyLevelLoading = true;
            state.getDifficultyLevelSuccess = {};
            state.getDifficultyLevelError = '';
        },
        setGetDifficultyLevelSuccess: (state, action) => {
            state.getDifficultyLevelLoading = false;
            state.getDifficultyLevelSuccess = action.payload;
            state.getDifficultyLevelError = '';
        },
        setGetDifficultyLevelError: (state, action) => {
            state.getDifficultyLevelLoading = false;
            state.getDifficultyLevelSuccess = {};
            state.getDifficultyLevelError = action.payload;
        },
        setCreateDifficultyLevelLoading: (state) => {
            state.createDifficultyLevelLoading = true;
            state.createDifficultyLevelSuccess = {};
            state.createDifficultyLevelError = '';
        },
        setCreateDifficultyLevelSuccess: (state, action) => {
            state.createDifficultyLevelLoading = false;
            state.createDifficultyLevelSuccess = action.payload;
            state.createDifficultyLevelError = '';
        },
        setCreateDifficultyLevelError: (state, action) => {
            state.createDifficultyLevelLoading = false;
            state.createDifficultyLevelSuccess = {};
            state.createDifficultyLevelError = action.payload;
        },
        resetDetails: (state) => {
            state.getDifficultyLevelSuccess = {};
            state.createDifficultyLevelSuccess = {};
        },
    }
})

export const { setDifficultyLevelListLoading, setDifficultyLevelListSuccess, setDifficultyLevelListError,
    setGetDifficultyLevelLoading, setGetDifficultyLevelSuccess, setGetDifficultyLevelError, 
    setCreateDifficultyLevelLoading, setCreateDifficultyLevelSuccess, setCreateDifficultyLevelError,
    resetDetails
} = difficultyLevelSlice.actions;


export default difficultyLevelSlice.reducer;